import React from "react";

export default function BulkActionBar({
  selectedCount,
  eligibleCount,
  onClear,
  onRequest,
  requesting = false,
  requestDisabled = false,
  onExport,
  exporting = false,
}) {
  return (
    <div className="bulk-action-bar">
      <span className="bulk-selection-text">
        Selected: {selectedCount} ({eligibleCount} eligible)
      </span>
      <div className="bulk-action-buttons">
        <button className="btn-secondary" onClick={onClear} disabled={selectedCount === 0}>
          Clear selection
        </button>
        <button className="btn-secondary" onClick={onRequest} disabled={requestDisabled}>
          {requesting ? "Requesting..." : `Request approval (${eligibleCount})`}
        </button>
        <button className="btn-secondary" onClick={onExport} disabled={exporting}>
          {exporting ? "Exporting..." : "Export CSV"}
        </button>
      </div>
    </div>
  );
}
